import { render, staticRenderFns } from "./leadRow.vue?vue&type=template&id=31ec3fcc&scoped=true&"
import script from "./leadRow.vue?vue&type=script&lang=js&"
export * from "./leadRow.vue?vue&type=script&lang=js&"
import style0 from "./leadRow.vue?vue&type=style&index=0&id=31ec3fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec3fcc",
  null
  
)

export default component.exports